import React from 'react'
import { Typeahead, TypeaheadMenu } from 'react-bootstrap-typeahead'
import jump from 'jump.js'
import Button from '../../components/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-regular-svg-icons'
import styled from 'styled-components'
import { rem } from '../../styles/Mixins'
import { Container, media } from 'styled-bootstrap-grid'
import {
  CancerSelectBlue,
  CancerSelectBlueSmall,
  CancerSelectYellow,
  CancerSelectYellowSmall,
} from '../../assets/svgs'
import { StaticQuery, graphql } from 'gatsby'
import he from 'he'

const CancerTypeSection = styled.section`
  background-color: ${(props) => props.theme.colors.primary};

  ${Container} {
    ${media.xl`
      padding: 0;
      max-width: ${(props) =>
        props.theme.settings.container_horizontal_maxWidth_xl};
    `}

    ${media.xxl`
      max-width: ${(props) =>
        props.theme.settings.container_horizontal_maxWidth_xxl};
    `}

    @media (min-width: 1920px) {
      max-width: 1348px;
    }
  }
`
const CancerTypeOutter = styled.div`
  max-width: 2200px;
  width: 100%;
  margin: 0 auto;
  position: relative;
  padding: 75px 0 115px;

  ${media.xl`
    padding-top: 125px;
    padding-bottom: 150px;
  `}

  ${media.xxl`
    padding-top: 135px;
    padding-bottom: 150px;
  `}

  @media (min-width: 1920px) {
    padding-top: 200px;
    padding-bottom: 230px;
  }

  :after {
    content: url(${CancerSelectBlueSmall});
    position: absolute;
    z-index: 1;
    right: -10px;
    top: 30px;

    ${media.xl`
      content: url(${CancerSelectBlue});
      right: -75px;
    `}

    ${(props) => props.theme.media.xxxl`
      right: -50px;
      top: 45px;
    `}
  }

  :before {
    content: url(${CancerSelectYellowSmall});
    position: absolute;
    z-index: 1;
    left: 30px;
    bottom: -5px;

    ${media.xl`
      content: url(${CancerSelectYellow});
      transform: scale(.6);
      bottom: -63px;
    `}

    @media (min-width: 1920px) {
      left: 10px;
      bottom: -5px;
      transform: none;
    }
  }
`

const CancerTypeInner = styled.div`
  text-align: center;
  position: relative;

  .btn-disabled {
    pointer-events: none;
    cursor: default;
    opacity: 0.3;
    background-color: ${(props) => props.theme.colors.primary_light};
    color: white;
  }
`

const CancerTypeSubtitleText = styled.p`
  font-family: 'foco_cc_bold', sans-serif;
  color: ${(props) => props.theme.colors.white};
  font-size: ${rem(15)};
  line-height: ${rem(22)};
  text-transform: uppercase;

  ${media.xl`
    font-size: ${rem(20, 'xxxl')};
  `}
`

const CancerTypeSubtitleYellow = styled.span`
  color: ${(props) => props.theme.colors.secondary_dark};

  ${media.xs`
    display: block;
  `}
`

const DropdownWrap = styled.div`
  margin: 40px auto 95px;
  display: block;
  transition: all 0.2s ease-out;
  justify-content: center;

  ${media.lg`
    display: flex;
    margin: 60px auto 70px;
  `}
`

const DropdownInnerWrap = styled.div`
  ${media.lg`
    position: relative;
    width: 290px;
  `}
`

const CancerSelectTypeahead = styled(Typeahead)`
  .dropdown-menu {
    justify-content: center;
    position: relative !important;
    transform: none !important;
    overflow: hidden !important;
    max-height: 194px !important;
    width: auto !important;

    ${media.lg`
      max-height: 215px !important;
    `}

    ${media.xl`
      max-height: 310px !important;
    `}

    a {
      font-family: 'foco_cc_bold', sans-serif;
      display: block;
      width: 100%;
      text-align: left;
      text-decoration: none;
      font-size: ${rem(16)};
      color: ${(props) => props.theme.colors.grey};
      margin-bottom: 10px;

      ${media.xl`
        font-size: ${rem(22, 'xxxl')};
      `}

      mark {
        background-color: ${(props) => props.theme.colors.secondary_dark};
      }
    }
  }

  > div:first-child {
    :after {
      content: '';
      position: absolute;
      z-index: 1;
      left: 0;
      bottom: 0;
      height: 2px;
      width: 100%;
      background-color: ${(props) => props.theme.colors.primary_light};

      ${media.lg`
        height: 4px;
        bottom: -5px;
      `}
    }
  }

  input {
    color: ${(props) => props.theme.colors.white};
    font-weight: 700;
    font-size: ${rem(28)};
    font-family: 'foco_cc_black', sans-serif;
    background: transparent;
    border: none;
    position: relative;
    outline: none;
    padding-bottom: 5px;
    transition: all 0.2s ease-out;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    padding-right: 20px;

    ::placeholder {
      color: #e6e8ef;
    }

    ::-ms-clear {
      display: none;
    }

    &:focus {
      color: ${(props) => props.theme.colors.primary_light};
    }

    ${media.xl`
      font-size: ${rem(45, 'xxxl')};
    `}
  }

  .rbt-input-hint {
    z-index: -1;
  }
`

const LoadMoreWrap = styled.div`
  position: relative;

  /* stylelint-disable-next-line */
  :after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    box-shadow: 0px -2px 20px 16px rgba(255, 255, 255, 1);

    ${media.lg`
      box-shadow: 0px 2px 20px 16px rgba(255,255,255,1);
    `}

    ${media.xl`
      box-shadow: 1px -20px 20px 16px rgba(255,255,255,1);
    `}
  }
`

const DropdownInner = styled.div`
  width: 190px;
  margin: auto;
  background-image: url('data:image/svg+xml,%3Csvg aria-hidden=%27true%27 data-prefix=%27fas%27 data-icon=%27angle-down%27 xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 320 512%27 class=%27svg-inline--fa fa-angle-down fa-w-10%27%3E%3Cpath fill=%27%23FFD200%27 d=%27M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z%27/%3E%3C/svg%3E');
  background-repeat: no-repeat;
  background-position: right;
  background-size: 15px;
  transition: all 0.2s ease-out;
  position: absolute;
  z-index: 2;
  left: 50%;
  transform: translateX(-50%);

  ${media.sm`
    width: 220px;
  `}

  ${media.lg`
    width: 250px;
  `}

  ${media.xl`
    width: 270px;
    margin-left: 15px;
    margin-top: 20px;
    background-position: 99% 23px;
    top: -21px;
  `}

  ${(props) => props.theme.media.xxxl`
    width: 300px;
    margin-left: 34px;
  `}

  @media screen and (min-width: 0\0) {
    background-size: 16px 25px;
    background-position-x: 100%;
  }

  .value-selected & {
    width: 310px;
    padding-top: 5px;

    ${media.lg`
      width: 250px;
      padding-top: 0;
    `}

    ${media.xl`
      width: 270px;
    `}

    ${(props) => props.theme.media.xxxl`
      width: 300px;
    `}

    input {
      font-size: 1.5rem;

      ${media.md`
        font-size: ${rem(28)};
      `}

      ${media.xl`
        font-size: ${rem(45, 'xxxl')};
      `}
    }
  }

  .rbt-aux {
    display: none;
  }

  &.menu-openned {
    border-radius: 0px 25px 25px 25px;
    background-color: ${(props) => props.theme.colors.white};
    padding: 15px 30px 35px;
    margin: -30px auto 0;
    width: 315px;
    box-shadow: 0px 10px 20px rgba(0,0,0,0.16);
    background-image: none;

    ${media.lg`
      width: 420px;
      margin-left: 85px;
      margin-top: 35px;
      background-position: 88% 30px;
      top: -51px;
    `}

    ${media.xl`
      background-position: 88% 33px;
    `}

    input {
      color: ${(props) => props.theme.colors.primary_light};
    }

    .menu-expanded {
      overflow-y: scroll !important;

      ::-webkit-scrollbar-track
      {
        box-shadow: inset 0 0 6px #e2e2e2;
        border-radius: 10px;
        background-color: #fff;
      }

      ::-webkit-scrollbar {
        width: 9px;

        ${media.md`
          width: 12px;
        `}
      }

      ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 6px #fff;
        background-color: #e6e8ef;
      }

      :after {
        display: none;
      }
    }

    > div {
      width: 90%;
      margin: auto;

      > div:first-child {
        :after {
          opacity: 0.1;
          background-color: ${(props) => props.theme.colors.primary};
        }
      }
    }

    button {
      border-radius: 0px 10px;
      padding: 10px 20px;
      font-size: ${rem(16)};
      margin-top: 15px;
      position: relative;
      z-index: 999;

      ${media.xl`
        font-size: ${rem(17, 'xxxl')};
        margin-top: 0;
      `}

      svg {
        margin-left: 15px;
        width: 11px;
        height: 14px;

        ${media.xl`
          margin-left: 19px;
        `}

        &.fa-spin {
          margin-left: 8px;
          width: auto;
        }
      }
    }

    .rbt-aux {
      display: block;
      position: absolute;
      z-index: 1;
      top: 7%;
      right: 0;
      height: 18px;
      width: 11px;
      opacity: 0.5;

      :hover {
        cursor: pointer;
        opacity: 0.7;
      }

      ${media.md`
        top: 10%;
      `}

      ${media.lg`
        top: 8%;
      `}

      ${media.xl`
        top: 12px;
      `}

      ${media.xxl`
        top: 15px;
      `}

      @media (min-width: 1650px) {
        top: 20px;
      }

      button {
        padding: 0;
        border: none;
        margin: auto;
        cursor: pointer;
        background: none;

        span {
          :first-child {
            font-size: 20px;

            ${media.lg`
              font-size: 25px;
            `}
          }
        }
      }
    }
  }
`

const DropdownDescription = styled.span`
  font-family: 'foco_cc_italic', sans-serif;
  color: ${(props) => props.theme.colors.white};
  font-weight: 700;
  font-size: ${rem(28)};

  ${media.xl`
    font-size: ${rem(45, 'xxxl')};
  `}
`

const CancerSelectTypeaheadMenu = styled(TypeaheadMenu)`
  padding-top: 15px;
  padding-right: 12px;
  margin-top: 13px;
`

class CancerTypeSelector extends React.Component {
  cancers = this.props.cancers
    .map((cancer) => {
      // remove duplicate slashes from uri
      const link = cancer?.uri?.replace(/\/\//g, '/')
      return {
        id: cancer.databaseId,
        label: he.decode(cancer.title),
        value: link,
      }
    })
    .sort((a, b) => {
      if (a.label.toUpperCase() > b.label.toUpperCase()) {
        return 1
      } else if (a.label.toUpperCase() < b.label.toUpperCase()) {
        return -1
      }
      return 0
    })

  state = {
    selectedCancer: [],
    menuExpanded: false,
    menuOpen: false,
    loading: false,
  }

  constructor(props) {
    super(props)
    this.typeaheadRef = React.createRef()
    this.changeTimeout = null
  }

  onCancerTypeChange = (item) => {
    this.setState({
      selectedCancer: item,
      menuExpanded: false,
    })

    clearTimeout(this.changeTimeout)
    this.changeTimeout = setTimeout(() => {
      if (this.typeaheadRef.current) {
        this.typeaheadRef.current.getInput().blur()
      }
    }, 500)
  }

  onCancerTypeInputChange = () => {
    clearTimeout(this.changeTimeout)
  }

  inputOnFocus = () => {
    if (window.matchMedia) {
      if (window.matchMedia(`(max-width: 767px)`).matches) {
        if (this.typeaheadRef.current) {
          const typeaheadInput = this.typeaheadRef.current.getInput()
          jump('.cancer-type-inner', {
            duration: 500,
            offset:
              -1 * (document.getElementById('main-header').offsetHeight - 5),
            a11y: false,
            callback: () => {
              typeaheadInput.focus()
            },
          })
        }
      }
    }
  }

  render() {
    const { selectedCancer, menuExpanded } = this.state

    if (!this.cancers || !this.cancers.length) {
      return null
    }

    return (
      <CancerTypeSection>
        <CancerTypeOutter>
          <Container>
            <CancerTypeInner className="cancer-type-inner">
              <CancerTypeSubtitleText>
                cancer causes questions. &nbsp;
                <CancerTypeSubtitleYellow>
                  learn more and be informed.
                </CancerTypeSubtitleYellow>
              </CancerTypeSubtitleText>
              <DropdownWrap>
                <DropdownDescription>
                  Show me information on
                </DropdownDescription>
                <DropdownInnerWrap
                  className={
                    this.state.selectedCancer.length > 0
                      ? 'value-selected'
                      : null
                  }
                >
                  <DropdownInner
                    className={this.state.menuOpen ? 'menu-openned' : ''}
                  >
                    <CancerSelectTypeahead
                      clearButton
                      id="cancer-type-selector"
                      options={this.cancers}
                      flip={true}
                      positionFixed={true}
                      highlightOnlyResult={true}
                      shouldSelect={(shouldSelect, e) => {
                        return e.keyCode === 13 || shouldSelect;
                      }}
                      onChange={this.onCancerTypeChange}
                      onInputChange={this.onCancerTypeInputChange}
                      selected={selectedCancer}
                      maxHeight="280px"
                      placeholder="Type Here"
                      onMenuToggle={(isOpen) => {
                        this.setState({ menuOpen: isOpen })
                      }}
                      ref={this.typeaheadRef}
                      onFocus={this.inputOnFocus}
                      inputProps={{
                        'aria-label': 'Search cancer types',
                      }}
                      renderMenu={(results, menuProps, state) => {
                        const moreCount = results.length - 7
                        return (
                          <>
                            <CancerSelectTypeaheadMenu
                              {...menuProps}
                              labelKey={state.labelKey}
                              options={results}
                              text={state.text}
                              className={
                                menuExpanded
                                  ? 'menu-expanded'
                                  : 'menu-collapsed'
                              }
                            />
                            {results.length > 7 && !menuExpanded && (
                              <LoadMoreWrap>
                                <Button
                                  loading={this.state.loading}
                                  onClick={() => {
                                    this.setState({
                                      loading: true,
                                    })

                                    setTimeout(() => {
                                      this.setState({
                                        menuExpanded: true,
                                        menuOpen: true,
                                        loading: false,
                                      })
                                      if (this.typeaheadRef.current) {
                                        this.typeaheadRef.current
                                          .getInput()
                                          .focus()
                                      }
                                    }, 1000)
                                  }}
                                  arrow={false}
                                >
                                  {`Show ${moreCount + 1} more`}
                                  {!this.state.loading ? (
                                    <FontAwesomeIcon icon={faPlus} />
                                  ) : null}
                                </Button>
                              </LoadMoreWrap>
                            )}
                          </>
                        )
                      }}
                    />
                  </DropdownInner>
                </DropdownInnerWrap>
              </DropdownWrap>
              <Button
                className={selectedCancer.length === 0 ? 'btn-disabled' : ''}
                href={
                  selectedCancer.length === 0
                    ? undefined
                    : selectedCancer[0].value
                }
                arrow={false}
                type={'primary'}
              >
                Get Information
              </Button>
            </CancerTypeInner>
          </Container>
        </CancerTypeOutter>
      </CancerTypeSection>
    )
  }
}

const CancerSelector = (props) => (
  <StaticQuery
    query={graphql`
      query {
        wpPage(slug: { eq: "home" }) {
          acfHomepage {
            showSection
          }
        }
        allWpCancerType(filter: { status: { eq: "publish" } }) {
          nodes {
            title
            uri
            databaseId
          }
        }
      }
    `}
    render={(data) => {
      return data?.wpPage?.acfHomepage?.showSection || props?.forceRender ? (
        <CancerTypeSelector cancers={data?.allWpCancerType?.nodes} />
      ) : null
    }}
  ></StaticQuery>
)

export default CancerSelector